import { FC, useMemo } from "react";
import { Item, ItemProps } from ".";

interface NumberProps extends ItemProps {
    value?: number;
    onChange?: (value?: number) => void;
    placeholder?: string;
    step?: number;
}
const Number: FC<NumberProps> = ({ value, onChange, col, error, label, placeholder, required, itemClassName, step }) => {
    const inputClassName = useMemo(() => {
        let className = `@app-form-number w-full border px-4 py-2 rounded focus:outline-none focus:border-blue-500`;
        if (Boolean(error)) {
            className += " border-red-500 focus:border-red-500 focus:ring-red-500";
        }
        return className;
    }, [error])
    return <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName}>
        <input
            step={step}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const { value } = e.currentTarget;
                onChange?.(value ? parseInt(value) : undefined);
            }}
            type="number"
            className={inputClassName}
            placeholder={placeholder}
        />
    </Item >
}

export default Number;